import React from "react";
import {  Box,
  Typography,
  Stack,
  alpha,
  useTheme,
  Divider,} from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  DirectionsBoat,
  Tag,
  LocationOn,
  CalendarMonth,
  Anchor,
} from "@mui/icons-material";
import { getVoyageNumber } from "../../utils/domainSelectors";
import { getSelectedTrip } from "../../utils/voyageSelection";

const VoyageInformationTable = ({
  currentVoyage,
  selectedTripId,
  loadingPorts,
  dischargePorts,
}) => {
  const theme = useTheme();

  let selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  if (!selectedTrip) {
    const fallbackTrips = Object.values(currentVoyage?.trips || {});
    selectedTrip = fallbackTrips[0] || {};
  }

  const InfoBlock = ({ label, value, icon: Icon, color }) => (
    <Stack direction="row" spacing={2} alignItems="flex-start">
      <Box
        sx={{
          p: 1.2,
          borderRadius: 2,
          bgcolor: alpha(color || theme.palette.primary.main, 0.08),
          color: color || theme.palette.primary.main,
          display: "flex",
          mt: 0.5,
        }}
      >
        <Icon sx={{ fontSize: 20 }} />
      </Box>
      <Box>
        <Typography
          variant="caption"
          fontWeight="900"
          color="text.disabled"
          sx={{
            letterSpacing: 1.2,
            textTransform: "uppercase",
            mb: 0.5,
            display: "block",
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          fontWeight="900"
          sx={{ lineHeight: 1.2, color: "text.primary" }}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Stack>
  );

  return (
    <Box sx={{ py: 1 }}>
      <Grid container spacing={4}>
        {/* Översta raden: Fartyg och Voyage */}
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <InfoBlock
            label="Vessel Name"
            value={currentVoyage?.vesselName || currentVoyage?.vessel}
            icon={DirectionsBoat}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <InfoBlock
            label="Voyage Number"
            value={getVoyageNumber(currentVoyage)}
            icon={Tag}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
          <InfoBlock
            label="C/P Date"
            value={selectedTrip?.cpDated}
            icon={CalendarMonth}
            color={theme.palette.secondary.main}
          />
        </Grid>

        <Grid size={12}>
          <Divider sx={{ borderStyle: "dashed", my: 1, opacity: 0.5 }} />
        </Grid>

        {/* Nedre raden: Hamnar */}
        <Grid size={{ xs: 12, sm: 6 }}>
          <InfoBlock
            label="Loading Port(s)"
            value={loadingPorts}
            icon={Anchor}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <InfoBlock
            label="Discharge Port(s)"
            value={dischargePorts}
            icon={LocationOn}
            color={theme.palette.info.main}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VoyageInformationTable;
